// removed by extract-text-webpack-plugin
module.exports = {"awardsContainer":"_1nzd","intro":"_2jHu","scroller":"u32b","item":"_3SIO","helper":"_1j-8","allAwardsContainer":"Viii"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/awards/style.css
// module id = 396
// module chunks = 9